<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" *ngIf="!editar">
    Nuevo ubigeo
  </h4>
  <h4 class="modal-title" id="modal-basic-title" *ngIf="editar">
    Editar ubigeo
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="_close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" style="padding: 10px">
  <form>
    <div class="form-group pl-2">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">

            <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Ubigeo:</label>
            <div class="col-md-2">
              <input [(ngModel)]="codigoUbigeo" style="text-align: center" class="form-control tsiInput"
                name="codigoUbigeo" type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                maxlength="10" disabled />
            </div>
            <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
          </div>

          <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">

            <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Departamento:</label>
            <div class="col-md-2">
              <input [(ngModel)]="codDepart" style="text-align: center" class="form-control tsiInput"
                (change)="onChangeDepartamento($event.target.value)" name="codClase" type="text"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="10" disabled />
            </div>
            <div class="col-md-7">
              <select [(ngModel)]="codDepart" tabindex="15" class="col-md-12 tsiSelect" name="codDepart" #selectClase
                (change)="onChangeDepartamento($event.target.value)">
                <option *ngFor="let claseSele of listaDepartamentos" value="{{ claseSele.codigo }}">
                  {{ claseSele.descri }}
                </option>
              </select>
            </div>
            <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
          </div>

          <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">

            <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Provincia:</label>
            <div class="col-md-2">
              <input [(ngModel)]="codProv" style="text-align: center" class="form-control tsiInput" name="codProv"
                type="text" (keydown.enter)="onKeyEnterProvincia($event)" (blur)="onBlurProvincia($event)"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="10" />
            </div>
            <div class="col-md-7">
              <select id="cboProvincia" [disabled]="disabledprov" [(ngModel)]="codProv" tabindex="15"
                (change)="onChangeProvincia($event.target.value)" class="col-md-12 tsiSelect" name="codProv">
                <option *ngFor="let codigoSele of listaprovincias" value="{{ codigoSele.codigo }}">
                  {{ codigoSele.provincia }}
                </option>
              </select>
            </div>
            <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
          </div>

          <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">

            <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Distrito:</label>
            <div class="col-md-2">
              <input [(ngModel)]="codDist" style="text-align: center" class="form-control tsiInput" name="codDist"
                type="text" (keydown.enter)="onKeyEnterDistrito($event)" (blur)="onBlurDistrito($event)"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="10" />
            </div>
            <div class="col-md-7">
              <select id="cboDistrito" [disabled]="disableddistr" [(ngModel)]="codDist" tabindex="15"
                class="col-md-12 tsiSelect" name="codDist" (change)="onChangeDistrito($event.target.value)">
                <option *ngFor="let codigoSele of listadistritos" value="{{ codigoSele.codigo }}">
                  {{ codigoSele.distrito }}
                </option>
              </select>
            </div>
            <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-rounded btn-info m-b-15" tabindex="5" (click)="_ok()">
    <i class="fa fa-save"></i> Guardar
  </button>
  <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="_close()" tabindex="6">
    <i class="fa fa-times-circle"></i> Cancelar
  </button>
</div>